export class VariablesZonaCompartida {

    public static readonly DATOS_COMPENSACION = 'datosCompensacion';
    public static readonly OBJETO_VISITA = 'objetoVisita';
    public static readonly DATOS_FUNCIONARIO = 'datosFuncionario';
    public static readonly TIPO_GENRACION = 'tipo';
    public static readonly DETALLE_GRUPO_DISCAPACIDAD = 'detalleGrupoDiscapacidad';
    public static readonly DATOS_FUNCIONARIO_ACTIVO_FIJO = 'datosFunActivoFijo';
    public static readonly DATOS_FUNCIONARIO_INCENTIVO_BICICLETA = 'datosFunIncentivoBicicleta';

    public static readonly TITULO_TIPO_CARGUE = 'CARGA MASIVA DE ';
    public static readonly INVENTARIO = 'INVENTARIO';
    public static readonly CONTRATISTA = 'CONTRATISTA';
    public static readonly ACTIVO_FIJO = 'ACTIVO_FIJO';
    public static readonly TERCERO = 'TERCERO';
    public static readonly PLANTA = 'PLANTA';

    public static readonly PANTILLA_ACTIVO_FIJO = 'RUTA_PLANTILLA_INV';
    public static readonly PLANTILLA_TERCERO = 'RUTA_PLANTILLA_TERCERO';
    public static readonly PLANTILLA_PLANTA = 'RUTA_PLANTILLA_PLANTA';
    public static readonly PLANTILLA_CONTRATISTA = 'RUTA_PLANTILLA_CONTRA';

    public static readonly PATH_OPC_ADMIN_PERSONAL_TERCE = "/administrar-funcionarios-tercerizados";
    public static readonly PATH_OPC_ADMIN_PERSONAL = "/administrar-funcionarios";
    public static readonly PATH_OPC_CARGA_INVENTARIO = "/main/registro-carga-inventario";

    public static readonly ROL_TALENTO_HUMANO = 'Administrador Talento Humano';

}